import { ConsentChangedEventObjectType } from "../../../types/oneTrust";

type ConsentChangedCallback = (e: ConsentChangedEventObjectType) => void;
const callbacks: ConsentChangedCallback[] = [];

export const ConsentManager = {
    addCallback: (callback: ConsentChangedCallback) => {
        if (!callbacks.includes(callback)) {
            callbacks.push(callback);
        }
    },

    notifyCallbacks: (e: ConsentChangedEventObjectType) => {
        callbacks.forEach(callback => callback(e));
        // callbacks may need to be cleaned up after completion, but currently is ok
    }
};